const Roles = {
  lender: "lender",
  admin: "admin",
  moderator: "moderator",
  advisor: "customer advisor",
};

export default Roles;
